
import React from 'react';
import { Shop } from '@/lib/supabase/shops/types';
import { 
  Card, 
  CardHeader, 
  CardTitle, 
  CardDescription, 
  CardContent
} from '@/components/ui/card';
import { PaymentMethodsList } from './payment-methods/PaymentMethodsList';
import { PaymentSettingsLoader } from './payment-methods/PaymentSettingsLoader';
import { usePaymentSettings } from './payment-methods/hooks/usePaymentSettings';

interface PaymentMethodsSectionProps {
  shop: Shop;
}

export const PaymentMethodsSection: React.FC<PaymentMethodsSectionProps> = ({ shop }) => {
  const {
    paymentSettings,
    isLoading,
    isSaving,
    handleTogglePaymentMethod,
    loadPaymentSettings
  } = usePaymentSettings(shop.id);

  if (isLoading) {
    return <PaymentSettingsLoader />;
  }

  return (
    <Card className="col-span-2">
      <CardHeader>
        <CardTitle>Méthodes de Paiement</CardTitle>
        <CardDescription>
          Gérez les méthodes de paiement disponibles pour vos clients
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <PaymentMethodsList 
          paymentSettings={paymentSettings}
          onTogglePaymentMethod={handleTogglePaymentMethod}
          isSaving={isSaving}
          shopId={shop.id}
        />
      </CardContent>
    </Card>
  );
};
